import { BasketIdentifier } from "@efood-commerce-sdk/typescript-axios-transaction-efood";
import dayjs from "dayjs";

// Function to create a unique key for a basket based on its identifier
const createBasketKey = (identifier: BasketIdentifier): string => {
  const deliveryDate = identifier.deliveryDate?.date
    ? dayjs(identifier.deliveryDate.date).toDate().getTime()
    : 0;

  return `${identifier.type}_${identifier.dropShipType ?? ""}_${identifier.sellerIdentifier?.identifier ?? ""}_${deliveryDate}`;
};

export { createBasketKey };
